import WithRender from "../../templates/base/productPartsNames.html";
import { mapMutations, mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActiveProductPartName"]),
    code: function () {
      return this.propsData.code;
    },
    name: function () {
      return this.propsData.label;
    }
  },

  methods: {
    ...mapActions(["setActiveProductPartName"]),
    activeClass: function () {
      return this.getActiveProductPartName == this.propsData.label
        ? "active"
        : "";
    }
  },

  props: ["propsData"]
});
